export default "__VITE_ASSET__CRZcEd5Z__"